<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#A6BBC8 " type = "ball-spin" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<router-outlet></router-outlet>